import { useState, useEffect } from 'react';

import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import { getArrayParam } from '@frontend/features/common/helper';

interface UseShowMineFilterProps {
  filterField: string;
  label: string;
  tooltip?: string;
  searchParams: URLSearchParams;
  updateFilters: (filters: Record<string, any>) => void;
}

export const useShowMineFilter = ({
  filterField,
  label,
  tooltip,
  searchParams,
  updateFilters,
}: UseShowMineFilterProps) => {
  const { myProfile } = useAuth();
  const [showMine, setShowMine] = useState<boolean>(false);

  useEffect(() => {
    if (myProfile?.id) {
      const currentIds = getArrayParam(searchParams.get(filterField));
      const isFilteringMine = currentIds?.length === 1 &&
        currentIds[0] === myProfile.id;
      setShowMine(isFilteringMine);
    }
  }, [searchParams, myProfile?.id, filterField]);

  const handleToggle = () => {
    if (!myProfile?.id) return;

    if (showMine) {
      updateFilters({ [filterField]: undefined });
      setShowMine(false);
    } else {
      updateFilters({ [filterField]: myProfile.id });
      setShowMine(true);
    }
  };

  const clearFilter = () => {
    setShowMine(false);
  };

  const actionToggle = myProfile?.id ? {
    key: 'showMine',
    isActive: showMine,
    onToggle: handleToggle,
    label,
    tooltip: tooltip || label
  } : null;

  return { actionToggle, clearFilter };
};
